import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';

import style from './style.module.css';

/**
 * Top section component: project summary shown in the page toolbar.
 *
 * @param props {Object}.
 * @param props.project {Immutable.Map} Project information.
 * @param props.common {Immutable.Map} General information.
 */
const TopSectionComponent = ({ project, common }) => {
  if (common.get('topLoading') || !project.get('id')) return null;

  const harvcoLeadElement = project.get('harvcoLead') ? `(${project.get('harvcoLead')})` : '';
  const projectLabel = `${project.get('category', '')} ${harvcoLeadElement}`;
  const harvcoLead = project.get('harvcoLead') || '(None)';
  const clientLead = project.get('clientLead') || '(None)';

  return (
    <div className={style.host}>
      <div className={style.field}>
        <span className="field-label">Buyer</span>
        <div className={style.value} title={project.get('buyer')}>
          <a href={`/company/${project.get('buyerId')}`} rel="noopener noreferrer" target="_blank">
            {project.get('buyer')}
          </a>
        </div>
      </div>
      <div className={style.field}>
        <span className="field-label">Project</span>
        <div className={style.value} title={projectLabel}>
          <a href={`/project/${project.get('id')}`} rel="noopener noreferrer" target="_blank">
            {projectLabel}
          </a>
        </div>
      </div>
      <div className={style.field}>
        <span className="field-label">HarvCo Lead</span>
        <div className={style.value} title={harvcoLead}>
          {harvcoLead}
        </div>
      </div>
      <div className={style.field}>
        <span className="field-label">Client Lead</span>
        <div className={style.value} title={clientLead}>
          {clientLead}
        </div>
      </div>
    </div>
  );
};

TopSectionComponent.propTypes = {
  common: PropTypes.instanceOf(Map).isRequired,
  project: PropTypes.instanceOf(Map).isRequired,
};

/** Top section component. */
export const TopSection = memo(TopSectionComponent);
